module.exports = __webpack_public_path__ + "static/img/5777_phase_function_Paper_PointsHejduk_Prediction.f5e73b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5777_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Kfx5
// module chunks = 0